import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { WebcamImage } from 'ngx-webcam';

@Component({
  selector: 'ark-patient-profile-camera',
  templateUrl: './patient-profile-camera.component.html',
  styleUrls: ['./patient-profile-camera.component.scss']
})
export class PatientProfileCameraComponent implements OnInit {
  public webcamImage: WebcamImage = null;
  constructor(
    public dialogRef: MatDialogRef<PatientProfileCameraComponent>,
  ) { }

  ngOnInit() {
  }

  cameraImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
    this.dialogRef.close(this.webcamImage.imageAsDataUrl);
  }

  getUploadedImage(event) {
    let data = {
      image: event,
      type: 1
    }
    this.dialogRef.close(data);
  }

  close() {
    this.dialogRef.close();
  }
}
